class BroadcastStateTransitionResponse {
  /**
   * @returns {BroadcastStateTransitionResponse}
   */
  static createFromProto() {
    return new BroadcastStateTransitionResponse();
  }
}

module.exports = BroadcastStateTransitionResponse;
